<template>
  <div :class="['col-xs-12', `col-md-${size}`]">
    <form-group-select
      ref="input"
      :label="label"
      :readonly="readonly"
      :name="name"
      :options="options"
      :data-vv-as="label"
      :placeholder="placeholder"
      :value="value"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "c-protocolo-tcc",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    size: {
      type: String,
      default: "6"
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  mounted() {
    this.$el.value = this.value;
  },
  computed: {
    options() {
      return [
        {
          value: "Individual",
          text: "Individual"
        },
        {
          value: "Dupla",
          text: "Dupla"
        }
      ];
    },
  },
  methods: {
    ...mapActions("atendimento",["setIsDupla"])
  },
  asyncComputed: {
    isDupla() {
      if (this.value == "Dupla") {
        this.setIsDupla(true);
      } else this.setIsDupla(false);
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/Tcc.vue